import { Box } from '@mui/material';

import YearTag from '../year-tag';

const IconBox = ({ iconSrc, yearDisplay, displayOnLeft }) => (
    <Box
        sx={(t) => ({
            position: 'relative',
            marginTop: '-15px',
            minHeight: '180px',
            marginBottom: '30px',
            '& .timeline-logo': {
                width: '100%',
                maxWidth: '180px',
                height: 'auto',
                marginLeft: displayOnLeft ? 0 : '80px',
                marginRight: displayOnLeft ? '80px' : 0
            },
            [t.breakpoints.down('md')]: {
                margin: '0',
                minHeight: '80px',
                flex: '0 80px',
                '& .timeline-logo': {
                    width: '80px',
                    maxWidth: '80px',
                    marginTop: '14px',
                    marginLeft: 0,
                    marginRight: 0
                }
            }
        })}
    >
        {iconSrc && (
            <img
                className="timeline-logo"
                alt={`Hotmob timeline logo at ${yearDisplay}`}
                src={iconSrc}
                width="186"
                height="186"
                loading="lazy"
            />
        )}
        <YearTag year={yearDisplay} position={displayOnLeft ? 'right' : 'left'} />
    </Box>
);

export default IconBox;
